import React, { useState, useEffect, useRef  } from "react";
import { styled, useTheme } from "@mui/material/styles";
import axios from "axios";
import { useSelector } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from 'react-router-dom';
import { Tooltip } from "@mui/material";
import CommonAlert from "../../../Commonalert/commonalert";
import KeywordEditForm from "./KeywordEditForm";
import DatagridComp from "../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import {Container, Grid, Box} from '@mui/material';

const PreferredList = (props) => {


  const [cardData, setCardData] = useState([]);
  const [keywordData, setKeywordData] = useState("Country");
  const [loading, setLoading] = useState(false);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [columns, setColumns] = useState([]);
  const [deleteId, SetDeleteId] = useState("")
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [keywordeditpopup, setKeywordEditPopup] = useState(false);
  const [selectedKeyword, setSelectedKeyword] = useState('');
  const [submitKeyword, setSubmitKeyword] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [succespopup, setsuccespopup] = useState();
  const [keywordaddpopup, setkeyWordAddPopup] = useState(false);

  const navigate = useNavigate();


  const handleDeleteClick = (id) => {
    SetDeleteId(id);
    setIsOpen(true);
  };

  const handleConfirmDelete = () => {
    DeleteBrandedterm(deleteId);
  };

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const GetDefaultSettings = async () => {
    setLoading(true);
    setKeywordData([]);
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}settings/keywordsettings_view/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      setLoading(false);
      var firArray = [
        {
          field: "campaign_name",
          headerName: "Campaign Name",
          minWidth: 200,
          flex: 1,
          headerAlign: "center",
          sortable: true,
          disableClickEventBubbling: true,
          description: 'Campaign names that have been added to the domain.',
        },

        {
          field: "keyword_name",
          headerName: "Keyword Name",
          minWidth: 200,
          flex: 1,
          headerAlign: "center",
          sortable: true,
          disableClickEventBubbling: true,
          description: 'The list of keywords is provided in campaign settings.',
        },

      ];
      setColumns(firArray)
      if (datavalue.data) {
        var testValue = datavalue.data.keyword_settings;

        var fourArray = [{
          field: "edit",
          headerName: "Edit",
          minWidth: 200,
          flex: 1,
          headerAlign: "center",
          align: "center",
          sortable: false,
          disableClickEventBubbling: true,
          renderCell: (cardData) => {
            return (
              <Tooltip title={'Click here to edit the keyword'}>
                <a className="EditBrandedTermClass" href="javascript:void(0)" data-id={cardData.row.id}>
                  <button className="buttonView edit_icon keyword-edit-icon" onClick={EditBrandedTerm}>

                    <EditIcon className="edit-icon-svg" />
                  </button>
                </a>
              </Tooltip>
            );
          },
        },
        {
          field: "delete",
          headerName: "Delete",
          minWidth: 200,
          flex: 1,
          headerAlign: "center",
          align: "center",
          disableClickEventBubbling: true,
          sortable: false,
          renderCell: (cardData) => {
            return (
              <Tooltip title={'Click here to delete the keyword'}>
                <a className="DeleteBrandedtermClass" href="javascript:void(0)" >
                  <button className="buttonView trash_icon keyword-delete-icon"
                    onClick={() => handleDeleteClick(cardData.row.id)}


                    id={cardData.row.id}>

                    <DeleteIcon className="delete-icon-svg" />
                  </button>
                </a>
              </Tooltip>
            );
          },
        }]
        var c = firArray.concat(fourArray)
        setColumns(c)

      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "") => {
    setLoading(true);
    setTableLoading(true);

    try {

      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/v2/keyword_table/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });


      if (datavalue?.data?.result) {
        if (datavalue?.data?.result) {
          const newData = datavalue?.data?.result.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          SetAutoheightval(false)
          setCardData(newData);
        }
      }
      else {
        SetAutoheightval(true)
        setCardData([]);
      }

    } catch (err) {
      console.log(err)
    }

    props.setSubmitKeyword(false);
    setSubmitKeyword(false);
    setLoading(false);
    setTableLoading(false);

  };


  const EditBrandedTerm = (e) => {
    const Id = e.target.closest(".EditBrandedTermClass").getAttribute("data-id");
    setSelectedKeyword(Id);
    setKeywordEditPopup(true);
  }

  const DeleteBrandedterm = async (deleteid) => {
    setIsOpen(false);
    const Id = deleteid
    try {

      await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/keyword_delete/?user_domain_id=${esodata.domaindata.value.header_selected}&keyword_id=${Id}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
        return false;
      });
      setSubmitKeyword(true);

    } catch (err) {
      console.log(err)
    }

  }

  function closeModal() {
    setIsOpen(false);
  }

  const keywordaddpopupCloseOk = () => {
    setkeyWordAddPopup(false);
    setSubmitKeyword(true);
  }

  useEffect(() => {
    GetDefaultSettings()
    callUserdataApi()
  }, [])

  useEffect(() => {
    if (props.CallPreferredList === true || props.submitKeyword == true || submitKeyword) {

      callUserdataApi()
    }

  }, [props.CallPreferredList, submitKeyword, props.submitKeyword])

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
 
  const handleDownlodingCSV = () => {
  props.csvdown();
  }

  const handleDownlodingPDF = () => {
   props.pdfdown();
  }

  

  return (
    <div>

      <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "30px", marginBottom: "20px" }} >
        <Box style={{ background: "#fff", padding: "0px 20px 0px 20px" }} className="grid_table_shodow">
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0, 200]}
                  tableLoading={tableLoading}
                  customFilter={false}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                  DownloadShowFile={true}
                  handleDownlodingPDF={handleDownlodingPDF}
                  handleDownlodingCSV={handleDownlodingCSV}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "5px", marginBottom: "5px" }} >
        <Box style={{ padding: "0px 20px 0px 20px" }} >
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={6}>
              <div><p style={{ color: "#000" }}>All Rights Reserved Copyright © 2025 | <span style={{ color: "#ff601f" }}> eGrove Systems</span></p></div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div style={{ display: "flex", gap: "30px", justifyContent: "end" }}>
                <p>
                  {/* <span
                          style={{ color: "#818181", cursor: "pointer" }}
                          onClick={handleToggle}
                        >
                          FAQ's
                        </span> */}
                </p></div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      {/* <DatagridComp
        columns={columns}
        rows={rows}
        autoheightval={autoheightval}
        datagridval={2}
        customFilter={false}
        columnFreezeWidth={[0, 200]}
        tableLoading={tableLoading}
      /> */}

      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">

              Are you sure you want to delete this Keyword Name?

            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button className="form_submit_btn" onClick={handleConfirmDelete} style={{ cursor: 'pointer' }} >
            OK
          </button>
          <button style={{ cursor: 'pointer' }} onClick={closeModal}>close</button>
        </DialogActions>
      </Dialog>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
      <Dialog
        open={keywordeditpopup}
        onClose={() => setKeywordEditPopup(false)}
        PaperProps={{
          className: 'keyword-dialog',
        }}
      >
        <DialogTitle className="keyword-dialog-header">{"Edit Keywords"}</DialogTitle>
        <DialogContent className="update-user-dialog">
          <KeywordEditForm
            setKeywordEditPopup={setKeywordEditPopup}
            selectedKeyword={selectedKeyword}
            setSubmitKeyword={setSubmitKeyword}
            setsuccespopup={setsuccespopup}
            setkeyWordAddPopup={setkeyWordAddPopup}
          />
        </DialogContent>
      </Dialog>
      <CommonErrorAlert
        data={{
          apiopen: keywordaddpopup,
          apiErrorMsg: succespopup,
          isIconStyled: false
        }}
        closeAlert={keywordaddpopupCloseOk} />

    </div>)

}
export default PreferredList